<template lang="pug">
  .div
    .columns
      h1.is-size-4
          strong Formulario Peaje
    .columns
      .column.is-4
        .field
          label.label Dispositivo
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Dispositivo..',
                v-model="dispositivo",
                :disabled="isDisabled"
              )
      .column.is-4
        .field
          label.label Estatus
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Estatus..',
                v-model="status",
                :disabled="isDisabled"
              )
    .columns
      .column.is-2
        a.button.is-block(@click="cancelAdd")
          | Cancelar 
      .column.is-2
        a.button.is-black.is-block(@click="checkForm")
          | Guardar 
    .columns(v-show="datosFaltantes.length > 0")
      .notification
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
</template>

<script>
  import ResponsivasService from '@/services/inventario/responsivas'

  export default {
    name: 'FormPeaje',
    props: {
      item: {
        type: Object,
        default: () => {}
      },
    },
    data() {
      return {
        dispositivo: null,
        status: null,
        datosFaltantes: [],
        isDisabled: false,
        datosForm: {}
      }
    },
    watch: {
      item() {
        if (Object.keys(this.item).length > 0) {
          this.dispositivo = this.item.serie
        }
      }
    },
    methods: {
      checkForm() {
        this.datosFaltantes = []
        if (this.dispositivo && this.status) {
          let myObject = {
            dispositivo: this.dispositivo,
            status: this.status
          }
          this.datosForm = Object.assign({}, this.datosForm, myObject)
          this.isDisabled = true
          this.guardar()
        } else {
          if (!this.dispositivo) {
            this.datosFaltantes.push('La Tarjeta es requerida.')
          }
          if (!this.status) {
            this.datosFaltantes.push('El Estatus es requerido.')
          }
        }
      },
      guardar() {
        this.$emit('closeForm', this.datosForm)
      },
      cancelAdd() {
        this.datosFaltantes = []
        // this.dispositivo = null
        // this.status = null
        this.isDisabled = false
        console.log('Cancelar')
        this.$emit('closeForm','close')
      }
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/responsivas_Componentes/components/FormPeaje.vue